export const generateFileName = (filename = '') => {
    if (!filename) {
        return `export_${Date.now()}.xlsx`;
    }

    const cleaned = filename.replace(/"/g, '').trim();
    return cleaned.includes('.') ? cleaned : `${cleaned}.xlsx`;
};
